import { Inject } from '@odinjs/odin';
import { AppointmentDashboardCardAPI } from '@philips-emr/patient-components/src';
import { ButtonAPI, DeckAPI, LayoutAPI, ModalService, PanelAPI, TrailAPI } from '@philips-internal/oswald-ui-components';
import { ActionAPI, FetchAPI } from '@philips-internal/oswald-ui-components/lib/components';
import { ModalButtonType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnAfterFetch, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { AbortableCloseEvent, ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BrokerService, HttpService, MediaType, MessageService, } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { foundationContext, Information } from '@philips-internal/oswald-ui-foundation/lib';
import { getBreakpoint, isMobile } from '@philips-internal/oswald-ui-utils';
import { getFoundationDataContext } from '../../../src/app/bootstrap-foundation';
import { TasyRescheduleParameters } from '../../../src/interfaces/tasy-parameters';
import AppointmentService from '../../../src/services/appointment-service';
import { ApplicationModulesIds } from '../../app/module-registry/application-modules';
import { DashboardAliases, FragmentNames } from '../../codegen';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { APPOINTMENT_TYPE } from '../../constants/appointment-type';
import { SCHEDULE_CODE_TYPE } from '../../constants/schedule-code-type';
import { ScheduleType } from '../../constants/schedule-type';
import { ScheduleTasksProgress } from '../../interfaces/schedule-tasks-progress';
import { HttpServiceError, PatientHttpService } from '../../services/patient-http-service';
import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { cast, clone } from '../../utils/cast-helpers';
import { defaultIfUndefined } from '../../utils/object-utils';
import RescheduleContext, { rescheduleCancelModal } from '../../utils/reschedule-utils';
import TasksContext from '../../utils/tasks-context';
import { showToastNotificationError, showToastNotificationSuccess } from '../../utils/toast-notification-utils';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { UrlTelemedicine } from '../home/patient-root-controller';
import PseudonymCancelService from '../pseudonym-appointments/pseudonym-service/pseudonym-cancel-service';
import './dashboard-controller.css';
import { BS_CHANGE_USER } from '../../constants/application-constants';

class EventListenerController {
  static reloadDashboardListener: EventListener | undefined;
  static updateModulesRoute: EventListener | undefined;
}

interface TaskCardValue {
  eventType: string;
  nrSeqAtendimento?: number;
  scheduleNumber?: number;
}

interface paramsQuestionairePA {
  dsTipoAvaliacao: string;
  nrSeqTipoAvaliacao: number
}

const parameterValues = {
  NO: 'N',
  YES: 'S'
}

@Controller({ component: 'layout-outer', fragment: 'dashboard' })
export default class DashboardController extends BaseController {

  @Inject('deck-exams')
    deckExams!: DeckAPI;

  @Inject(DashboardAliases.TRAIL_WAITING_LIST_API)
    trailWaitingListApi!: TrailAPI;

  @Inject('deck-task-list')
    deckTaskListApi!: DeckAPI;

  @Inject(DashboardAliases.APPOINTMENTS_TRAIL)
    appointmentsTrail!: TrailAPI;

  @Inject('root-layout')
    rootLayout!: LayoutAPI;

  @Inject(DashboardAliases.BOTTOM_LAYOUT)
    bottomLayoutApi!: LayoutAPI;

  @Inject(DashboardAliases.UPPER_LAYOUT)
    upperLayoutApi!: LayoutAPI;

  @Inject(DashboardAliases.PANEL_APPOINTMENT)
    panelAppointment!: PanelAPI;

  @Inject(DashboardAliases.MY_PROPERTIES_PANEL)
    panelExams!: PanelAPI;

  @Inject(DashboardAliases.PANEL_TASKS)
    panelTaskApi!: PanelAPI;

  @Inject(DashboardAliases.PANEL_UPPER_LAYOUT)
    panelUpperLayoutApi!: PanelAPI;

  @Inject(DashboardAliases.PANEL_BOTTOM_LAYOUT)
    panelBottomLayout!: PanelAPI;

  @Inject(DashboardAliases.PA_WAITING_PANEL)
    waitingPanel!: PanelAPI;

  @Inject('panel-waiting-list')
    waitingListPanelAPI!: PanelAPI;

  @Inject('button-cancel')
    buttonCancelApi!: ButtonAPI;

  @Inject('button-going')
    buttonGoingApi!: ButtonAPI;

  @Inject(DashboardAliases.APPOINTMENT_DASHBOARD_CARD)
    appointmentDashboardCardApi!: AppointmentDashboardCardAPI;

  @Inject(DashboardAliases.APPOINTMENTS_FETCH)
    appointmentListFetchAPI!: FetchAPI;

  openConfirmModal = true;
  showWaitingList = parameterValues.NO;

  @Inject(DashboardAliases.FETCH_WAITING_LIST)
    fetchWaitingList!: FetchAPI;

  @Inject(DashboardAliases.ACTION_NEW_APPOITMENT)
    actionNewAppoinmentApi!: ActionAPI;

  @Inject('PseudonymCancelService')
    pseudonymCancelService!: PseudonymCancelService;

  pushRouteByOpenModule(moduleId: string, route: string, params: Record<string, Value> | undefined = undefined, isExamRoute = false ): void {
    const pathParameters = isExamRoute ? {} : params;
    const queryParameters = isExamRoute ? params : {};

    applicationContext.openModule(moduleId, {
      at: {
        options: {
          searchParams: queryParameters,
        },
        params: cast(pathParameters),
        path: route,
      }
    });

    applicationContext.pushNavigationItem(() => {
      applicationContext.openModule(ApplicationModulesIds.DASHBOARD);
    });
  }

  updateModulesRoute = ( event: Event ): void => {
    if ( event ) {
      const customEvent = event as CustomEvent;

      if ( !customEvent.detail ) {
        return
      }

      const moduleId = customEvent.detail.moduleId;
      const module = applicationModuleRegistry.get(moduleId);
      let route = APPLICATION_ROUTES.HOME_DASHBOARD;

      if( !module ) {
        return;
      }

      switch ( moduleId ) {
        case ApplicationModulesIds.APPOINTMENTS: route = this.getAppointmentRoute();
          break;
        case ApplicationModulesIds.EXAMS: route = APPLICATION_ROUTES.EXAMS;
          break;
      }

      module.route = route;
    }
  }

  reloadDashboard(patientId: number): void {
    UserContext.patientId = patientId;
    this.setPatientIdInContext(patientId);
  }

  removeEventListener(): void {
    if (EventListenerController.reloadDashboardListener) {
      removeEventListener('reloadDashboard', EventListenerController.reloadDashboardListener);
      EventListenerController.reloadDashboardListener = undefined;
    }

    if (EventListenerController.updateModulesRoute) {
      removeEventListener('updateModulesRoute', EventListenerController.updateModulesRoute);
      EventListenerController.updateModulesRoute = undefined;
    }
  }

  reloadDashboardListener = (e: Event): void => {
    const ce: CustomEvent = e as CustomEvent;
    const patientId = ce.detail.patientId as number;
    this.reloadDashboard(patientId);
  }

  addEventListener(): void {
    this.removeEventListener();
    addEventListener('reloadDashboard', this.reloadDashboardListener);

    this.removeEventListener();
    addEventListener('updateModulesRoute', this.updateModulesRoute);
  }

  @OnMount({ target: 'layout-outer' })
  onlayoutOuterMount(): void {
    this.setPatientIdInContext(UserContext.patientId);
    this.setAppointmentRoutesInContext();
    this.addEventListener();

    BrokerService.subscribeToTopic(BS_CHANGE_USER, (patientId: number) => {
      this.verifyIfHasScheduleTasksInProgress(patientId);
    });
  }

  @OnMount({ target: DashboardAliases.LAYOUT_DASHBOARD })
  onMountAppointmentPanel(): void {
    this.actionNewAppoinmentApi.setEnabled(false);
    /** TO-DO Remove when jackson properly quote strings in JSON format */
    const options = {
      headers: {
        accept: MediaType.TEXT_PLAIN,
      }
    };
    HttpService.get(APPLICATION_ENDPOINTS.NEW_SCHEDULING_ALLOWED, {}, options).then(response => {
      if (response.body !== 'N') {
        this.actionNewAppoinmentApi.setEnabled(true);
      }
    });
  }

  @OnMount({ target: 'panel-appointment' })
  onMountPanelAppointment(): void {
    /** TO-DO Remove when jackson properly quote strings in JSON format */
    const options = {
      headers: {
        accept: MediaType.TEXT_PLAIN,
      }
    };
    HttpService.get(APPLICATION_ENDPOINTS.SCHEDULING_ACTIVE, {}, options).then(response => {
      if (response.body === 'N') {
        this.panelAppointment.setVisible(false);

        const style = this.getStylePanelUpperLayout();
        this.changeVisibilityPanels(this.panelTaskApi, this.upperLayoutApi, style, this.panelUpperLayoutApi);
      }
    });
  }

  @OnMount({ target: DashboardAliases.BOTTOM_LAYOUT})
  async onMountWaitingPanel(): Promise<void> {
    await HttpService.get(APPLICATION_ENDPOINTS.WAITING_LIST, {}, {headers: {accept: MediaType.TEXT_PLAIN}})
      .then(res => {
        this.showWaitingList = res.body as string;
        if (this.showWaitingList === parameterValues.YES) {
          this.fetchWaitingList.forceFetch();
          return;
        }

        this.waitingPanel.setVisible(false);

        const style = this.getStylePanelBottomLayout();
        this.changeVisibilityPanels(this.panelExams, this.bottomLayoutApi, style, this.panelBottomLayout);
      })
  }

  @OnMount({ target: DashboardAliases.MY_PROPERTIES_PANEL })
  onMountPanelExam(): void {
    if(isMobile()) {
      this.actionNewAppoinmentApi.setText('patient.new-record');
    }

    /** TO-DO Remove when jackson properly quote strings in JSON format */
    const options = {
      headers: {
        accept: MediaType.TEXT_PLAIN,
      }
    };

    HttpService.get(APPLICATION_ENDPOINTS.EXAMS_RESULT_AVAILABLE, {}, options).then(response => {
      if (response.body === 'N') {
        this.panelExams.setVisible(false);

        const style = this.getStylePanelBottomLayout();
        this.changeVisibilityPanels(this.waitingPanel, this.bottomLayoutApi, style, this.panelBottomLayout);
        return;
      }
    });
  }

  @OnMount({ target: DashboardAliases.PANEL_TASK_LIST})
  handlePanelTask(): void {
    const { patientId } = UserContext;
    this.verifyIfHasScheduleTasksInProgress(patientId);
  }

  @OnClick({ target: ['deck-exams'] })
  async onCardExamDeckClick(event: ClickEvent): Promise<void> {
    if (event && event.value) {
      const lastMonth = new Date();
      lastMonth.setMonth(new Date().getMonth() - 1);
      const { nrSequencia, nrPrescricao, type, dtProcedimento, cdMedico } = event.value;
      const { patientId } = UserContext;
      let examsDetailRoute = '';
      let params = {};
      if (type === 'L') {
        examsDetailRoute = APPLICATION_ROUTES.EXAM_LAB_DETAILS;

        params = {
          cdMedico: cdMedico as string,
          dtProcedimento: dtProcedimento as string,
          filterExamStatus: 'ALL',
          filterExamType: 'ALL',
          filterFromDate: lastMonth.toISOString() as string,
          patientId,
        }
      } else {
        examsDetailRoute = APPLICATION_ROUTES.EXAM_DETAILS;
        params = {
          dtProcedimento: dtProcedimento as string,
          examType: type as string,
          filterExamStatus: 'ALL',
          filterExamType: 'ALL',
          filterFromDate: lastMonth.toISOString() as string,
          nrPrescricao: nrPrescricao as string,
          nrSequencia: nrSequencia as string,
          patientId,
        }
      }

      this.pushRouteByOpenModule(ApplicationModulesIds.EXAMS, examsDetailRoute, params, true);
    }
  }

  @OnClick({ target: 'action-appointments' })
  onClickAllAppointments(): void {
    applicationContext.openModule(ApplicationModulesIds.APPOINTMENTS, { preventNavigation: false });
    this.checkNavigationDesktop();
  }

  @OnClick({ target: 'action-exams' })
  onClickAllExams(): void {
    applicationContext.openModule(ApplicationModulesIds.EXAMS, { preventNavigation: false });
    this.checkNavigationDesktop();
  }

  @OnClick({ target: DashboardAliases.ACTION_NEW_APPOITMENT })
  onClickNewAppointment(): void {
    const { patientId } = UserContext;
    const appointmentFormRoute = this.getAppointmentFormRoute();
    this.pushRouteByOpenModule( ApplicationModulesIds.APPOINTMENTS, appointmentFormRoute, { patientId, preventNavigation: false } );
    this.checkNavigationDesktop();
  }

  @OnClick(DashboardAliases.ACTION_TASKS)
  onClickAllTasks(): void {
    TasksContext.nrSeqAgenda = undefined;
    TasksContext.nrAtendimento = undefined;
    TasksContext.taskDateToFilter = undefined;
    applicationContext.openModule(ApplicationModulesIds.TASKS, { preventNavigation: false });
    this.checkNavigationDesktop();
  }

  @OnClick({ target: 'schedule-tasks-progress-card' })
  onClickTaskCard(event: ClickEvent): void {
    const cardData = event.value as TaskCardValue;
    TasksContext.nrSeqAgenda = cardData.scheduleNumber;
    TasksContext.nrAtendimento = cardData.nrSeqAtendimento;
    TasksContext.eventType = cardData.eventType;
    TasksContext.taskDateToFilter = undefined;
    applicationContext.openModule(ApplicationModulesIds.TASKS, { preventNavigation: false });
  }

  @OnAfterFetch({ target: 'fetch-exams' })
  onAfterFetchExams(event: FetchEvent): void {
    if (event && event.data) {
      const examList = event.data as Record<string, Value>[];
      const limit = this.deckExams.getLimit();

      examList.forEach(exam => {
        exam.review = exam.ieReview && exam.ieReview === 'S' ? true : false;
      });

      if (examList.length >= limit) {
        this.deckExams.setData(examList.slice(0,limit) as []);
      }
    }
  }

  @OnAfterFetch({ target: DashboardAliases.APPOINTMENTS_FETCH })
  handleAfterFetchAppointment(event: FetchEvent): void {
    if(!(event?.data)){
      return;
    }

    this.appointmentsTrail.setData(event.data as Record<string, Value>[]);
    this.checkIfCanSetItensPerTrailOnAppointmentsTrail();
  }

  @OnAfterFetch({ target: 'fetch-task-list' })
  onAfterFetchTasksProgressList(event: FetchEvent): void {
    if (event && event.data) {
      const tasksProgressList = event.data as ScheduleTasksProgress[];
      const limit = this.deckTaskListApi.getLimit();
      this.context.set({'taskProgress':tasksProgressList})
      const deckData = tasksProgressList.map(schedule => {
        const isExamSchedule = schedule.ieTipoAgenda === SCHEDULE_CODE_TYPE.EXAM;
        return {
          calculatedBlockedTasks: schedule.calculatedBlockedTasks,
          completedTasks: schedule.tarefasConcluidas,
          date: schedule.dsDate,
          eventType: schedule.typeCadEvent,
          ieTipoAgenda: schedule.ieTipoAgenda,
          nrSeqAtendimento: schedule.nrSeqAtendimento,
          scheduleNumber: schedule.nrSeqAgenda,
          title: isExamSchedule ? schedule.dsTitulo : this.getAppointmentTitle(schedule.dsTitulo,schedule.dsSubTitulo),
          totalTasks: schedule.totalTarefas,
        }
      }).filter(schedule => (schedule.completedTasks < schedule.totalTasks && schedule.calculatedBlockedTasks !== schedule.totalTasks));

      this.deckTaskListApi.setData(deckData.slice(0, limit) as []);
    }
  }

  getAppointmentTitle(dsTitulo: string, dsSubTitulo: string): string {
    return dsSubTitulo ?  `${dsTitulo} - ${dsSubTitulo}` :  `${MessageService.translate('schedule-type.consultation')} - ${dsTitulo}`
  }

  setCardContext (appointmentType: APPOINTMENT_TYPE, nrSeq: string): void {
    const appointmentDetailRoute = this.getAppointmentDetailRoute();
    this.pushRouteByOpenModule( ApplicationModulesIds.APPOINTMENTS, appointmentDetailRoute, { appointmentType, nrSeq } );
  }

  @OnClick({ target: ['appointments-trail'] })
  onCardAppointmentsTrailClick(event: ClickEvent): void {
    if (event && event.value != null) {
      const { ieScheduleType, nrSequencia } = event.value;

      switch(ieScheduleType) {
        case ScheduleType.CONSULTATION: this.setCardContext(APPOINTMENT_TYPE.CONSULTATIONS, nrSequencia); break;
        case ScheduleType.EXAM: this.setCardContext(APPOINTMENT_TYPE.EXAMS, nrSequencia); break;
        case ScheduleType.SERVICE: this.setCardContext(APPOINTMENT_TYPE.SERVICES, nrSequencia); break;
        case ScheduleType.SURGERY: this.setCardContext(APPOINTMENT_TYPE.SURGERIES, nrSequencia); break;
        case ScheduleType.CHEMOTHERAPY: this.setCardContext(APPOINTMENT_TYPE.CHEMOTHERAPIES, nrSequencia); break;
        case ScheduleType.REQUEST: this.setCardContext(APPOINTMENT_TYPE.REQUEST, nrSequencia); break;
        case ScheduleType.WAITING_LIST: this.setCardContext(APPOINTMENT_TYPE.WAITING_LIST, nrSequencia); break;
      }
    }
  }

  pushNewAppointment(): void {
    const appointmentFormRoute = this.getAppointmentFormRoute();
    this.pushRouteByOpenModule( ApplicationModulesIds.APPOINTMENTS, appointmentFormRoute );
  }

  checkNavigationDesktop(): void {
    const isDesktop = !isMobile();

    if (isDesktop) {
      return;
    }

    applicationContext.pushNavigationItem(() => {
      applicationContext.openModule(ApplicationModulesIds.DASHBOARD);
    });
  }

  makeNewEmergencyAppointment(nrSequence : number, selectedTitle: string): void {
    if (UserContext.patientId && UserContext.patientId !== 0){
      HttpService.get(APPLICATION_ENDPOINTS.GET_WAITING_LIST_QUESTIONAIRE, {}).then(response => {
        const responseBody = response.body as paramsQuestionairePA
        if(responseBody?.nrSeqTipoAvaliacao) {
          const questionaireParams = {
            nrSeqAvaliacao: responseBody.nrSeqTipoAvaliacao,
          }

          BrokerService.subscribeToTopic('openConfirmModal', (status: boolean) => {
            this.openConfirmModal = status
            if (status === true){
              this.openWaitingListConfirmModal(false, nrSequence, selectedTitle);
            }
          })

          ModalService.openDefault({
            closeable: true,
            contextData: questionaireParams,
            fragment: 'questionnaire',
            id: 'patient-questions-pa-modal',
            onClose: () => {
              if (!this.openConfirmModal) {
                this.openWaitingListConfirmModal(false, nrSequence, selectedTitle);
                this.openConfirmModal = true;
                return;
              }
            },
            title: responseBody.dsTipoAvaliacao,
          });
        } else {
          this.openWaitingListConfirmModal(false, nrSequence, selectedTitle);
        }
      });
    } else {
      this.postWaitingList(nrSequence, selectedTitle);
    }
  }

  cancelEmergencyAppointment(): void {
    this.openWaitingListConfirmModal(true, 0, '');
  }

  @OnClick({ target: DashboardAliases.CARD_WAITING_LIST_0 })
  onClickWaitList(event : ClickEvent): void {
    const nrSequence = event.value?.sequencePACard;
    const joinedQueue = event.value?.joinedQueue;
    const selectedTitle = event.value?.title;

    if (joinedQueue) {
      this.cancelEmergencyAppointment();
    } else {
      this.makeNewEmergencyAppointment(nrSequence, selectedTitle);
    }
  }

  async postWaitingList(nrSequencia : number, title : string): Promise<void> {
    const data = this.trailWaitingListApi.getData().map(item => ({...item, joinedQueue: true, selectedTitle: title}));

    await HttpService.post(APPLICATION_ENDPOINTS.POST_WAITING_LIST, {nrSequence: nrSequencia}).then(() => {
      showToastNotificationSuccess(MessageService.translate('patient.action.completed.sucessfully'));
      this.trailWaitingListApi.setData([...data])
    })
  }

  confirmCancelAction = (): void => {
    const data = this.trailWaitingListApi.getData().map(item => ({...item, joinedQueue: false }));
    HttpService.put(APPLICATION_ENDPOINTS.PUT_WAITING_LIST_CANCEL_DATE, {}).then(() => {
      this.trailWaitingListApi.setData([...data]);
    })
  }

  openWaitingListConfirmModal(cancelAction: boolean, nrSequencia : number, selectedTitle : string): void {
    const dialogDescription = cancelAction ? 'patient.dialog.cancel-message' : 'patient.like.to.join.queue';

    ModalService.openDialog({
      closeable: false,
      dialogDescription,
      dockButtons: [
        {
          action: () => { return },
          title: 'patient.modal.button-cancel',
          type: ModalButtonType.CANCEL
        },
        {
          action: (): void => {
            cancelAction ? this.confirmCancelAction() : this.postWaitingList(nrSequencia, selectedTitle)
          },
          title: 'patient.moda.button-yes',
          type: ModalButtonType.SUCCESS
        }
      ],
      id: 'waiting-list-confirmation-modal',
      onClose: () => { return },
      title: 'patient.cancel-reschedule-confirmation',
    });
  }

  @OnClick({ target: 'button-cancel' })
  onClickButtonCancel(): void {
    this.openWaitingListConfirmModal(true, 0, '');
  }

  @OnMount({target:DashboardAliases.APPOINTMENT_DASHBOARD_CARD})
  onMountAppointmentCard(evt: MountEvent):void{
    BrokerService.subscribeToTopic('updateDashboardCard', (patientId: number) => this.reloadDashboard(patientId))

    const patientId = UserContext.patientId;

    const card = evt.target as AppointmentDashboardCardAPI;
    card.setOnEnterTeleconsultation(this.onEnterTeleconsultation);
    card.setOnAppointmentRescheduleMore(this.handleAppointmentRescheduleMore);
    card.setOnAppointmentReschedule(this.handleAppointmentReschedule);
    card.setOnAppointmentCancel(this.handleAppointmentCancel);
    card.setOnAppointmentConfirm(this.handleAppointmentConfirm);

    card.setPatientId(patientId);

    HttpService.get(APPLICATION_ENDPOINTS.TASY_RESCHEDULE_PARAMETERS)
      .then(res => {
        const rescheduleParameters = res.body as TasyRescheduleParameters;
        card.setRescheduleConsultation(rescheduleParameters.reagendarConsulta, rescheduleParameters.reagendarExame, rescheduleParameters.reagendarServico);
      });
  }

  private onEnterTeleconsultation = (nrSeqAgendaConsulta: number, ieScheduleType: string): void => {
    const patientId = UserContext.patientId;

    PatientHttpService.get(APPLICATION_ENDPOINTS.GET_URL_TELEMEDICINE, {
      ieScheduleType,
      nrSeqAgendaConsulta,
      patientId
    }).then(response => {
      const urlTelemedicina = response.body as UrlTelemedicine;
      BrokerService.publishToTopic('iframe-teleconsulta', { patientUrl: urlTelemedicina.patientUrl });
    }).catch(({ response }: HttpServiceError<string>) => {
      const message = defaultIfUndefined(response?.body, 'newaccount.error.internal.server.error.try.again');
      showToastNotificationError(message);
    });
  }

  private handleAppointmentRescheduleMore = (): void => {
    const { patientId } = UserContext;

    applicationContext.openModule(ApplicationModulesIds.APPOINTMENTS);

    ModalService.openFullscreen({
      closeable: true,
      contextData: { patientId },
      fragment: FragmentNames.RESCHEDULE_TRANSFERENCE_MODAL,
      id: FragmentNames.RESCHEDULE_TRANSFERENCE_MODAL,
      onBeforeClose: (event) => this.handleBeforeCloseRescheduleModal(event),
      onClose: () => { return },
      title: 'reschedule.title',
    });
  }

  private handleBeforeCloseRescheduleModal(event: AbortableCloseEvent): void {
    event.abort();

    if (RescheduleContext.hasInsuranceSelected) {
      ModalService.openDialog(rescheduleCancelModal);
    } else {
      ModalService.close(FragmentNames.RESCHEDULE_TRANSFERENCE_MODAL);
      RescheduleContext.hasInsuranceSelected = false;
    }
  }

  private handleAppointmentReschedule = (sequenceSchedule: number, scheduleType: string): void => {
    const listItem = `${sequenceSchedule},`;
    const body = (scheduleType === ScheduleType.CONSULTATION || scheduleType === ScheduleType.SERVICE)
      ? { listaConsultaP: listItem, listaExameP: '' }
      : { listaConsultaP: '', listaExameP: listItem };

    HttpService.post(
      APPLICATION_ENDPOINTS.RESCHEDULE_ITEMS_TRANSFERENCE, { patientId: UserContext.patientId }, { body }
    ).then(response => {
      RescheduleContext.nrSeqAgeint = response.body as number;
      this.pushRouteByOpenModule( ApplicationModulesIds.APPOINTMENTS, APPLICATION_ROUTES.RESCHEDULE_APPOINTMENTS );
    });
  }

  private handleAppointmentCancel = (patientId: number, scheduleType: string, status: string, sequenceSchedule: number): void => {
    const cancelSubmitAction = (): void => { this.appointmentListFetchAPI.forceFetch() };
    this.pseudonymCancelService.cancelItem(patientId, sequenceSchedule, scheduleType, status, cancelSubmitAction);
  }

  private handleAppointmentConfirm = (patientId: number, scheduleType: string, scheduleCode: number, sequenceSchedule: number): void => {
    const confirmSubmitAction = (): void => { this.appointmentListFetchAPI.forceFetch() };
    this.pseudonymCancelService.confirmItem(patientId, scheduleCode, sequenceSchedule, scheduleType, confirmSubmitAction);
  }

  private setPatientIdInContext(patientId: number): void {
    this.context.set({ patientId: patientId });
  }

  private setAppointmentRoutesInContext(): void {
    this.context.set({
      appointmentDetailRoute: AppointmentService.getAppointmentDetailRoute(),
      appointmentFormRoute: AppointmentService.getAppointmentFormRoute(),
      appointmentRoute: AppointmentService.getAppointmentRoute(),
    });
  }

  private getAppointmentRoute(): APPLICATION_ROUTES {
    return this.context.get('appointmentRoute') as APPLICATION_ROUTES;
  }

  private getAppointmentFormRoute(): APPLICATION_ROUTES {
    return this.context.get('appointmentFormRoute') as APPLICATION_ROUTES;
  }

  private getAppointmentDetailRoute(): APPLICATION_ROUTES {
    return this.context.get('appointmentDetailRoute') as APPLICATION_ROUTES;
  }

  private changeTaskModuleState(patientCode: number): void {
    const appContext = getFoundationDataContext();
    const applicationInformationDataOriginal = appContext.get('applicationInformationData') as Information;
    const applicationInformationDataTemp = clone<Information, Information>(applicationInformationDataOriginal);
    const currentModulesAvailable = foundationContext.getAvailableModules() || [];

    if (!this.panelTaskApi.isVisible()) {
      applicationContext.setHiddenModule(ApplicationModulesIds.TASKS, true);
      applicationInformationDataTemp.module.available = currentModulesAvailable.filter(module => module.id !== ApplicationModulesIds.TASKS);
    } else {
      applicationInformationDataTemp.module.available = currentModulesAvailable;
    }

    foundationContext.clearInformation();
    foundationContext.setInformationOnce(applicationInformationDataTemp);

    const event = new CustomEvent('reloadDashboard', { detail: { patientId: patientCode } });
    dispatchEvent(event);
  }

  private changeVisibilityTaskPanel(columns: string): void {
    if (!this.panelAppointment.isVisible() && !this.panelTaskApi.isVisible()) {
      this.panelUpperLayoutApi.setVisible(false);
      return;
    }

    this.setPanelColums(this.upperLayoutApi, columns);
    this.checkIfCanSetItensPerTrailOnAppointmentsTrail();
  }

  private changeVisibilityPanels(panelToChangeColumns: PanelAPI, layoutApi: LayoutAPI, columns: string, panelLayoutApi: PanelAPI): void {
    if (!panelToChangeColumns.isVisible()) {
      panelLayoutApi.setVisible(false);
      return;
    }

    this.setPanelColums(layoutApi, columns);
  }

  private checkIfCanSetItensPerTrailOnAppointmentsTrail(): void {
    const appointmentsTrailData = this.appointmentsTrail.getData() as Record<string, Value>[];

    const itemsPerPage = this.panelTaskApi.isVisible() ? 2 : 3;
    if (appointmentsTrailData && appointmentsTrailData.length > 0) {
      this.appointmentsTrail.setItemsPerPage(itemsPerPage);
    }
  }

  private async verifyIfHasScheduleTasksInProgress(patientId: number): Promise<void> {
    const tasksProgressList = await HttpService.get(APPLICATION_ENDPOINTS.GET_SCHEDULE_TASKS_PROGRESS, { patientId }).then(response => {
      return response.body as ScheduleTasksProgress[];
    });

    const tasksProgressListFilter = tasksProgressList.filter(schedule => (
      schedule.tarefasConcluidas < schedule.totalTarefas && schedule.calculatedBlockedTasks !== schedule.totalTarefas
    ));

    if (tasksProgressListFilter.length) {
      this.panelUpperLayoutApi.setVisible(true);
      this.panelTaskApi.setVisible(true);

      const style = this.getStylePanelUpperLayout();
      this.changeVisibilityTaskPanel(style);
      this.changeTaskModuleState(patientId);
      return;
    }

    this.panelTaskApi.setVisible(false);
    const style = this.getStylePanelUpperLayout();
    this.changeVisibilityPanels(this.panelAppointment, this.upperLayoutApi, style, this.panelUpperLayoutApi);
    this.changeTaskModuleState(patientId);
  }

  private getStylePanelUpperLayout(): string {
    if (Breakpoint.LG == getBreakpoint()) {
      return this.getColumnsLayoutPanel(this.panelAppointment, this.panelTaskApi);
    }

    return this.getRowsLayoutPanel(this.panelAppointment, this.panelTaskApi);
  }

  private getStylePanelBottomLayout(): string {
    if (Breakpoint.LG == getBreakpoint()) {
      return this.getColumnsLayoutPanel(this.panelExams, this.waitingPanel);
    }

    return this.getRowsLayoutPanel(this.panelExams, this.waitingPanel);
  }

  private getColumnsLayoutPanel(firstPanelApi: PanelAPI, secondPanelApi: PanelAPI): string {
    if (firstPanelApi.isVisible() === secondPanelApi.isVisible()) {
      return firstPanelApi.isVisible() ? '60% 40%' : '0% 0%';
    }

    return firstPanelApi.isVisible() ? '100% 0%' : '0% 100%';
  }

  private getRowsLayoutPanel(firstPanelApi: PanelAPI, secondPanelApi: PanelAPI): string {
    if (firstPanelApi.isVisible() === secondPanelApi.isVisible()) {
      return firstPanelApi.isVisible() ? 'auto auto' : '0% 0%';
    }

    return firstPanelApi.isVisible() ? 'auto 0%' : '0% auto';
  }

  private setPanelColums(layoutApi: LayoutAPI, columns: string): void {
    if (Breakpoint.LG == getBreakpoint()) {
      layoutApi.setColumns(columns);
      return;
    }

    layoutApi.setRows(columns);
  }
}
